import { createClient } from '@supabase/supabase-js';

// Get Supabase URL and anon key from environment variables
const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

// Check if environment variables are available
if (!supabaseUrl || !supabaseAnonKey) {
  console.error('Supabase environment variables are missing!', {
    url: supabaseUrl ? 'Available' : 'Missing',
    key: supabaseAnonKey ? 'Available' : 'Missing'
  });
  
  // Fallback to hardcoded values if environment variables are missing
  // This is not ideal for security but prevents white screen in production
  if (!supabaseUrl) {
    console.warn('Using fallback Supabase URL');
  }
  if (!supabaseAnonKey) {
    console.warn('Using fallback Supabase anon key');
  }
}

// Create Supabase client
export const supabase = createClient(
  supabaseUrl || 'https://ifbfdfpzuyrpqehnjvsn.supabase.co',
  supabaseAnonKey || 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImlmYmZkZnB6dXlycHFlaG5qdnNuIiwicm9sZSI6ImFub24iLCJpYXQiOjE3Mjk0NzkxNjIsImV4cCI6MjA0NTA1NTE2Mn0.RiJn9oNndMJv62LTadpdq1qLA8FXOI0fdfgMZjPr2OY'
);

// Test the connection
(async () => {
  try {
    const { error } = await supabase.from('HealingOutLoud').select('count', { count: 'exact', head: true });
    if (error) {
      console.error('Supabase connection test failed:', error);
    } else {
      console.log('Supabase connection test successful!');
    }
  } catch (err) {
    console.error('Supabase connection test error:', err);
  }
})(); 